// extracted by mini-css-extract-plugin
export default {"order-none":"OrderEmpty_order-none__z9LZi","order-none-text":"OrderEmpty_order-none-text__Zf3c2"};